import { TableCell, TableRow, Typography, IconButton, Collapse, Box, useMediaQuery, Button } from '@mui/material';
import React, { useState } from 'react';
import Iconify from 'src/components/iconify';
import { useTranslation } from 'react-i18next';
import { FormatNumber, glb_sv } from 'src/utils';
import Label from 'src/components/label';
import EmtyData from 'src/components/emty-data';
import ItemRow from './itemRow';
import ButtonAction from 'src/components/Button.js/SaveButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MenuActionsItem from './MenuActionItem';
const Item = ({
    item,
    index,
    STATUS_COLOR,
    dataRef,
    setVisibleApprove,
    setVisibleReject,
    openButton,
    openRowIndex,
    setOpenRowIndex,
    setVisibleImageQR,
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    const user = glb_sv.userInfo;
    const isAdmin = user.group_user == '1';
    const isMobile = useMediaQuery('(max-width:750px)');
    return (
        <>
            <TableRow onClick={() => setOpenRowIndex(openRowIndex === index ? null : index)} hover key={index}>
                <TableCell padding="checkbox" />
                <TableCell padding="checkbox">
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpenRowIndex(openRowIndex === index ? null : index);
                        }}
                    >
                        <Iconify icon={openRowIndex === index ? 'mdi:chevron-up' : 'mdi:chevron-down'} />
                    </IconButton>
                </TableCell>
                <TableCell padding="checkbox">{index + 1}</TableCell>
                <TableCell padding="checkbox">
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            setVisibleImageQR(true);
                            dataRef.current = item;
                        }}
                    >
                        <Iconify icon="clarity:qr-code-line" />
                    </IconButton>
                </TableCell>
                <TableCell>
                    <Label color={STATUS_COLOR[item.status]}>{item.status_name}</Label>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="info">
                        {item.code}
                    </Typography>
                </TableCell>
                <TableCell>{item.create_time && glb_sv.formatDate(item.create_time, 'YYYYMMDDHHmmss')}</TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.user_request_nm}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.user_approve_nm}
                    </Typography>
                </TableCell>
                <TableCell>
                    {item.approve_or_reject_date && glb_sv.formatDate(item.approve_or_reject_date, 'YYYYMMDDHHmmss')}
                </TableCell>
                <TableCell>
                    <Typography variant="body2" fontWeight={600}>
                        {FormatNumber(item.total_price)}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.note}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.note_reject}
                    </Typography>
                </TableCell>

                {/* <Box sx={{ width: '255px' }}></Box> */}
                {item.status === '0' && (
                    <TableCell
                        padding="checkbox"
                        sx={{
                            position: 'sticky',
                            right: 0,
                            backgroundColor: '#f4f6f8',
                            zIndex: 3,
                        }}
                    >
                        {isMobile ? (
                            <>
                                <IconButton
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setAnchorEl(e.currentTarget);
                                    }}
                                >
                                    <MoreHorizIcon />
                                </IconButton>
                                <MenuActionsItem
                                    {...{
                                        item,
                                        isAdmin,
                                        dataRef,
                                        setVisibleApprove,
                                        setVisibleReject,
                                    }}
                                    open={openMenu}
                                    anchorEl={anchorEl}
                                    onClose={(e) => {
                                        e.stopPropagation();
                                        setAnchorEl(null);
                                    }}
                                />
                            </>
                        ) : (
                            <>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: 2,
                                        alignItems: 'center',
                                        height: '100%',
                                        px: 2, // padding ngang cho đẹp
                                    }}
                                >
                                    <ButtonAction
                                        type="confirm"
                                        title={t('confirm')}
                                        color={'confirm'}
                                        fullWidth
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setVisibleApprove(true);
                                            dataRef.current = item;
                                        }}
                                        sx={{ whiteSpace: 'nowrap' }}
                                    />

                                    <ButtonAction
                                        type="cancel"
                                        title={t('cancel')}
                                        color={'error'}
                                        fullWidth
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setVisibleReject(true);
                                            dataRef.current = item;
                                        }}
                                        sx={{ whiteSpace: 'nowrap' }}
                                    />
                                </Box>
                            </>
                        )}
                    </TableCell>
                )}

                <TableCell padding="checkbox"></TableCell>
                <TableCell padding="checkbox"></TableCell>
            </TableRow>

            {/* Row con */}
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                    <Collapse in={openRowIndex === index} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="subtitle2" gutterBottom>
                                {t('detail_request')}
                            </Typography>
                            {item.list_item?.length > 0 ? (
                                item.list_item.map((child, i) => <ItemRow key={i} child={child} item={item} />)
                            ) : (
                                <EmtyData />
                            )}
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default Item;
